import { exportContactsCsv } from '@/api/contacts'
import type { ContactList } from '@/api/lists'

/** Download the list's contacts as a CSV named after the list (to print, or to send someone). */
export async function downloadListCsv(list: ContactList) {
  const blob = await exportContactsCsv({ list: list.id })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${list.name.replace(/[^\w\- ]+/g, '').trim() || 'list'}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
